/**
 * Created by claudio iozzia on 26/06/2017.
 */
import {IUpdateDesign, UpdateDesign} from "../../../models/IUpdateDesign";
import {Ic} from "../../../models/common";
import {Warning} from "../../../models/warning";
import {isNullOrUndefined} from "util";
import {ISingleOutput} from "../../../models/ISpec";
import {IAppSpec} from "../../../Redux/selector.state";
import {Utils, tassign} from "../../../common/utils";
import {IC_fsw} from "../../../models/IC_fsw";

export class UpdateDesign_DcDc_Buck extends UpdateDesign {

  protected updateDesign_SingleOutput(ic: Ic, spec: IAppSpec, out: ISingleOutput<number>, i: number): Ic {
    const warning: Warning = this.Ton_i(ic, spec, out);
    const _ic_warning = isNullOrUndefined(ic.warning)
      ? new Warning(warning.msg, warning.severity)
      : ic.warning.reset(warning.msg, warning.severity);

    return tassign(ic, {warning: _ic_warning});
  }

  protected Ton_i(ic: Ic, spec: IAppSpec, out: ISingleOutput<number>): Warning {
    const _fsw: IC_fsw = new IC_fsw(ic);

    if (Utils.isValueEmpty(out.voltage) || Utils.isValueEmpty(out.current)) {
      return Warning.None;
    } // niente da validare

    const warning: Warning = new Warning();
    const iout: number = Utils.getFieldValue(out, "current", 0);

    const dmax: number = this.dutyCycle(ic, spec.spec.value.input.min, out.voltage, iout);
    const dmin: number = this.dutyCycle(ic, spec.spec.value.input.max, out.voltage, iout);

    const f_Vmax: number = _fsw.max_fton(dmin);
    const f_Vmin: number = _fsw.max_fton(dmax);

    if (f_Vmax < _fsw.fosc_min) {

      let report: string = '';
      let warning_severity: number = 1;

      // Completamente Disgiunti: Nessuna frequenza disponibile --> Errore Rosso; il Chip andrebbe filtrato
      if (f_Vmin < _fsw.min) {
        warning_severity += 1e6;
      }

      report = 'ton msg 1';

      let dv: number = f_Vmin - f_Vmax; // iSpec.VinMax - iSpec.VinMin;
      if (dv === 0) {
        dv = 1;
      }

      const v_rating: number = (_fsw.fosc_min - f_Vmax) / dv;

      if (v_rating > 0) { // if( f_Vmax < ic.fsw.min )
        report = 'ton msg 2';
        warning_severity += v_rating;
      } else { // questo else è di sicurezza ma non serve.
        report = 'ton msg 3';
      }

      const f_rating: number = ((_fsw.max - _fsw.min) / dv) / 1e6;
      warning_severity += f_rating;
      if (_fsw.selectable && f_Vmin < _fsw.max) {
        report = report.includes('msg 2') ? 'ton msg 2 fsw' : 'ton msg 3 fsw';
      }
      warning.reset(report, warning_severity);
    }

    return warning;
  }

  protected dutyCycle(ic: Ic, vin: number, vout: number, iout: number): number {
    const Vsw_i: number = Utils.getFieldValue(ic, "designData.Rds0", 0); // VinputSwitch(Iout);

    const def_Vsw_o: number = Vsw_i === 0 ? 0 : 0.5;

    const Vsw_o: number = Utils.getFieldValue(ic, "designData.Rds_ls0", def_Vsw_o); // VoutputSwitch(Iout);

    const DCR: number = 90E-6; // 90u  inductor.dcr;

    const res: number = (vout + Vsw_o + DCR * iout) / (vin + Vsw_o - Vsw_i);
    return (0 < res && res <= 1 ? res : Number.POSITIVE_INFINITY);
  }
}


export class UpdateDesign_DcDc_BuckBoost extends UpdateDesign_DcDc_Buck {

  static dutyCycle_BuckBoost(ic: Ic, vin: number, vout: number, iout: number): number {
    const eff: number = Utils.getFieldValue(ic, "efficiency", 100) / 100;

    const res: number = 1 / (1 - eff + (vin + vout) * eff / vout);
    return (0 < res && res <= 1 ? res : Number.POSITIVE_INFINITY);
  }

  protected dutyCycle(ic: Ic, vin: number, vout: number, iout: number): number {
    return UpdateDesign_DcDc_BuckBoost.dutyCycle_BuckBoost(ic, vin, vout, iout);
  }
}
